import { type FC } from 'react';

import { NotClearedBadge } from '@/src/components/atoms/NotClearedBadge';
import { LearnerNotClearedTooltip } from '@/src/components/atoms/NotClearedTooltip/LearnerNotClearedTooltip';

export interface LearnerNotClearedBadgeProps {
  readonly learnerFirstName: string;
}

export const LearnerNotClearedBadge: FC<LearnerNotClearedBadgeProps> = ({ learnerFirstName }) => (
  <LearnerNotClearedTooltip cleared={false} learnerFirstName={learnerFirstName}>
    <NotClearedBadge />
  </LearnerNotClearedTooltip>
);
